import type { ElementType, FunctionComponent, ReactNode } from 'react'
import React from 'react'

import { ListItemBullet } from '../ListItemBullet'
import { ListItemCross } from '../ListItemCross'
import { ListItemNumber } from '../ListItemNumber'
import { ListItemTick } from '../ListItemTick'

export const ListItem: FunctionComponent<ListItemProps> = ({
  icon,
  children,
  className,
  appearance = 'bullet',
  ...rest
}) => {
  let listVariant = appearance as VariantType

  if (icon) {
    listVariant = icon as IconType
  }

  const ListItemComponent = listItemsMapper[listVariant]

  return (
    <ListItemComponent
      data-testid={`${listVariant}-listItem`}
      className={className}
      {...rest}
    >
      {children}
    </ListItemComponent>
  )
}

///////// IMPLEMENTATION /////////

export type AppearanceType = 'bullet' | 'number' | 'icon'
export type IconType = 'tick' | 'cross'

type VariantType = Exclude<AppearanceType, 'icon'> | IconType
type ListItemMapper = Record<VariantType, ElementType>

const listItemsMapper: ListItemMapper = {
  bullet: ListItemBullet,
  number: ListItemNumber,
  tick: ListItemTick,
  cross: ListItemCross,
}

export type ListItemProps = {
  /**
   * Decides which variant of list item with icon to render
   */
  icon?: string
  /**
   * CSS class name added to the list item component
   */
  className?: string
  /**
   * Decides which variant list item to render
   */
  appearance?: string
  children: ReactNode
} & Omit<React.HTMLAttributes<HTMLElement>, 'onCopy' | 'onCut' | 'onPaste'>
